import { Icon } from '@material-ui/core';
import clsx from 'clsx';
import CheckMark from 'components/icons/CheckMark';
import CategoriesIconsMap from 'components/icons/categories/CategoriesIconsMap';
import LegendBanner from 'components/small/legend-banner/LegendBanner';
import BenzemaTimer from 'components/medium/profil-banner/benzema-timer/BenzemaTimer';
import useAssetsCategories from 'hooks/asset-categories/useAssetCategories';
import React from 'react';
import { Trans } from 'react-i18next';
import WhiteListDisclaimer from '../../white-list-box-button/white-list-disclaimer/WhiteListDisclaimer';
import EarlyBirdSectionProps from './EarlyBirdSectionProps';
import './style.scss';

const EarlyBirdSection: React.FC<EarlyBirdSectionProps> = ({ assetViewModel, assetBackgroundViewModel, preSaleIsOpen, isPrimaryMarketWillStart, setPreSaleIsOpen, setPrivateSellIsOpen }) => {
    const showWhiteListButton: boolean = React.useMemo(() => !assetViewModel.PreSaleIsFinished && !preSaleIsOpen, [assetViewModel, preSaleIsOpen]);
    const { assetsCategories } = useAssetsCategories();
    const categoryName: string = assetViewModel.getCategoryName(assetsCategories);

    return (
        <div className="early-bird-section">
            <div className="asset-profil-header-img-container">
                <div style={{ borderColor: assetBackgroundViewModel.Color }} className="asset-profil-header-img-block">
                    <img src={assetBackgroundViewModel.BackgroundImage} className="asset-profil-banner-bg-category" alt={assetViewModel.AvatarPath + "-bg"} loading="lazy" />
                    <img src={assetViewModel.AvatarPath} className="asset-profil-banner-bg-avatar" alt={assetViewModel.AvatarPath || ""} loading="lazy" />
                </div>
            </div>
            <div className='asset-profil-banner-name'>{assetViewModel.AssetName}</div>
            <div className='asset-profil-banner-category-nameIcon'>
                <div className="flex container-profil-banner">
                    <Icon className='category-icon'>
                        {CategoriesIconsMap[categoryName.capitalizeFirstLetter()]}
                    </Icon>
                    <span className='category-name'>{categoryName ?? ''}</span>
                    {assetViewModel.isLegend() && <LegendBanner />}
                </div>
            </div>
            <div className={clsx("information-container", { 'early-bird': assetViewModel.isEarlyBirdEnable() })}>
                {isPrimaryMarketWillStart && <div className="benzema-timer-container">
                    <BenzemaTimer setPreSaleIsOpen={setPreSaleIsOpen} setPrivateSellIsOpen={setPrivateSellIsOpen} assetVM={assetViewModel} />
                </div>}
                {assetViewModel.IsWhiteListedPurchaseOpen &&
                    <div>
                        <p className="pre-sales-disclaimer">
                            <span className="icon-disclaimer">🔒</span>
                            <Trans
                                i18nKey={!assetViewModel.isEarlyBirdEnable() ? 'pre.sales.disclaimer.custom.profil' : "early-bird.disclaimer.custom.profil"} />
                        </p>
                        {assetViewModel.isEarlyBirdEnable() && <>
                            <p className="pre-sales-disclaimer">
                                <span className="icon-disclaimer">🏆</span>
                                <Trans i18nKey="early-bird.disclaimer2.custom.profil" />
                            </p>
                            <p className="pre-sales-disclaimer">
                                <span className="icon-disclaimer">🚀</span>
                                <Trans i18nKey="early-bird.disclaimer3.custom.profil" />
                            </p>
                        </>}
                    </div>
                }
                {showWhiteListButton && <WhiteListDisclaimer assetVM={assetViewModel} icon={<CheckMark />} />}
            </div>
        </div>
    )
}

export default EarlyBirdSection;
